import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { reportsViewInit } from '../reportsViewSlice';
import { RootState } from '../../../../store';
import { routingOnRouteToReports } from 'src/app/store/routingSlice';

type IN = ReturnType<typeof routingOnRouteToReports>;
type OUT = ReturnType<typeof reportsViewInit>;

export const ReportsViewOnRouteEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteToReports.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [reportsViewInit()];
    }),
  );
